import { __decorate, __metadata } from "tslib";
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Form, Dialog, Button, FormItem, Checkbox } from 'element-ui';
import { getVar, getAllVarsForLogin, postVar } from 'library-components/utils/environment';
import _ from 'lodash';
import PsInput from 'library-components/components/Input/Input.vue';
import { E_WECHAT_BIND_WAY } from '../WechatLogin/types';
import MobileVerifyCodeForm from 'library-components/components/MobileVerifyCodeForm/MobileVerifyCodeForm.vue';
import Alert from 'library-components/components/Alert/Alert.vue';
import { E_AlertType } from 'library-components/components/Alert/AlertImpl';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import { emailRe } from 'library-components/utils/regex';
import { getPublicKeyApi, loginSubmitApi, mobileLoginApi, mobileLoginRegisterApi, postLoginVerifyCode, postLoginEmailVerifyCode } from 'library-components/apis/login/login';
import JSEncrypt from 'jsencrypt';
import { E_Switch } from 'library-components/apis/passport/passport.type';
import { applyAuthInterceptor } from 'library-components/config/authInterceptor';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
import { setUserAccountMobileNumber, removeMobileVerifyCodeCountDownTime, removeVerifyCodeCountDownTime, } from 'library-components/services/localStorage';
import { UserLoginMixin } from 'library-components/mixins/UserLoginMixin';
import { CLOSE } from 'library-components/apis/passport/error';
import { E_MobileVerifyCodePurpose } from 'library-components/apis/passport/types';
import { E_EMAIL_VERIFYCODE_PURPOSE } from 'library-components/apis/public/public.type';
import { PendoInsertMeta } from 'library-components/services/sentry';
import TermsOfServiceUpdate from 'library-components/components/TermsOfServiceUpdate/TermsOfServiceUpdate.vue';
import PtPopper from '@patsnap-biz/popper';
import '@patsnap-biz/popper/lib/style';
import 'tippy.js/dist/border.css';
let WechatBindDialogImpl = class WechatBindDialogImpl extends Mixins(UserLoginMixin) {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.wechatBindWay = E_WECHAT_BIND_WAY;
        this.curBindWay = E_WECHAT_BIND_WAY.SECURITY_VERIFICATION;
        this.agreeLegal = false;
        this.alertConfig = {
            showAlert: false,
            type: E_AlertType.info,
            title: '',
            content: '',
        };
        this.bindExistAccountAlertConfig = {
            showAlert: false,
            type: E_AlertType.info,
            title: '',
            content: '',
        };
        this.tippyJsErrorInstance = null;
    }
    get AlertConfig() {
        if (this.IsBindExistAccount) {
            return this.bindExistAccountAlertConfig;
        }
        return this.alertConfig;
    }
    get AlertVisible() {
        return this.AlertConfig.showAlert;
    }
    tippyJsErrorInstanceToggle() {
        if (this.agreeLegal) {
            this.tippyJsErrorInstance[0].hide();
            return;
        }
        this.tippyJsErrorInstance[0].show();
    }
    beforeDestroy() {
        this.tippyJsErrorInstance = null;
    }
    mounted() {
        PendoInsertMeta('Login', 'Open Wechat Bind Dialog');
        this.$nextTick(() => {
            this.tippyJsErrorInstance = PtPopper.tippy('.wechat-bind-dialog__container-agreeLegal', {
                trigger: 'manual',
                content: this.$t('passport.agreeTermsTooltip'),
                theme: 'warning',
                placement: 'bottom-start',
                zIndex: 10000,
                delay: 150,
                appendTo: () => document.body,
            });
        });
    }
    get IsBindExistAccount() {
        if (this.curBindWay === E_WECHAT_BIND_WAY.PHONE || this.curBindWay === E_WECHAT_BIND_WAY.EMAIL) {
            return true;
        }
        return false;
    }
    get CanPaidRegister() {
        if (this.commonService.IsInvitationSortCodeLink && this.isInvitationRegister) {
            return true;
        }
        if (this.commonService.IsPersonalInvitation) {
            return false;
        }
        return this.commonService.AllowRegiser;
    }
    get CanTrialRegister() {
        // return !this.commonService.AllowRegiser && !this.commonService.AnonymousLogin && !this.CanSecurityVerification
        return !this.CanPaidRegister && !this.CanSecurityVerification;
    }
    get CanSecurityVerification() {
        if (this.commonService.IsPersonalInvitation) {
            return true;
        }
        return (this.commonService.IsFromFreeProduct || this.commonService.IsFromEureka) && !this.commonService.AllowRegiser;
    }
    get RegisterComponent() {
        if (this.CanPaidRegister) {
            return () => import('library-components/components/PaidRegistration/PaidRegistration.vue');
        }
        if (this.CanTrialRegister) {
            return () => import('library-components/components/RegisterTrialForm/RegisterTrialForm.vue');
        }
    }
    get DialogTitle() {
        if (this.IsBindExistAccount) {
            return this.$t('passport.wechat.bindExistPatsnapAccount');
        }
        if (this.CanTrialRegister || this.CanPaidRegister) {
            return '';
        }
        return this.$t('passport.userLoginRegister');
    }
    get BackTitle() {
        return this.$t('passport.returnToRegister');
    }
    get AccountPwdBindPlaceholder() {
        return this.$t('passport.email_placeholder');
    }
    get AgreeLegalHtml() {
        return this.$t('passport.register.agreedToRulesText', {
            termsOfService: this.commonService.TermsOfService,
            privacyPolicy: this.commonService.PrivacyPolicy,
        });
    }
    get FormSmsPurpose() {
        if (this.IsBindExistAccount) {
            return E_MobileVerifyCodePurpose.LOGIN;
        }
        return E_MobileVerifyCodePurpose.LOGIN_REGISTER;
    }
    get clientId() {
        return _.get(this.commonService, 'client_id', '');
    }
    get from() {
        return _.get(this.commonService, 'from', '');
    }
    OnBindExistAccount() {
        this.curBindWay = E_WECHAT_BIND_WAY.PHONE;
        PendoInsertMeta('Register', 'Clicked WechatBindExistAccount');
    }
    onCurBindWayChange(way) {
        if ([E_WECHAT_BIND_WAY.PHONE, E_WECHAT_BIND_WAY.EMAIL].includes(way)) {
            PendoInsertMeta('Register', `Clicked WechatBindExistAccount (${way})`);
        }
    }
    OnBack() {
        this.curBindWay = E_WECHAT_BIND_WAY.SECURITY_VERIFICATION;
    }
    getToastMsg(errcode = null, email = '', loginUrl = '') {
        errcode = errcode || getVar('errorCode');
        email = email || getVar('email');
        const code = getVar('code');
        let type = 'error';
        if (!errcode && code) {
            type = 'success';
        }
        const urlData = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
        const paramsUrl = postVar({ ...urlData });
        const { msg, title } = getAlertDataByCode({
            code: errcode || code,
            lang: this.$i18n.locale,
            serviceArea: _.get(this.commonService, 'Region', '').toLocaleLowerCase(),
            userEmail: email,
            loginUrl,
            paramsUrl,
        });
        return { type, msg, title };
    }
    onPasswordKeyupEnter() {
        return this.emailBindSubmit();
    }
    async emailBindSubmit(mobileLoginData = {}) {
        if (this.isLoading)
            return;
        this.formPasswordRef.validate(async (valid) => {
            if (!valid) {
                return;
            }
            let { email, password } = this.formPassword;
            email = _.trim(email);
            password = _.trim(password);
            const isEmailLogin = emailRe.test(email);
            let loginBaseData = {};
            this.isLoading = true;
            try {
                const publicKey = await getPublicKeyApi();
                const encrypt = new JSEncrypt({});
                encrypt.setPublicKey(publicKey);
                const encryptPwd = encrypt.encrypt(password);
                loginBaseData = {
                    username: email,
                    password: encryptPwd,
                };
                if (!isEmailLogin) {
                    loginBaseData = this.getMobileLoginData(loginBaseData);
                }
                const preLoginParams = {
                    ...loginBaseData,
                    client_id: this.clientId,
                    authc_type: 'ACCOUNT_PASSWORD',
                };
                const checkStatus = await this.beforeLoginCheck(preLoginParams, isEmailLogin ? E_LoginMethod.password : E_LoginMethod.mobilePassword);
                if (!checkStatus)
                    return;
                let resGeetestValidate = {};
                if (this.isNeedCaptcha) {
                    resGeetestValidate = await this.geetestValidate();
                    if (resGeetestValidate === CLOSE) {
                        return;
                    }
                }
                const loginData = {
                    ...loginBaseData,
                    remember_me: E_Switch.On,
                    client_id: this.clientId,
                    from: this.from,
                    response_type: 'TOKEN',
                };
                const tokenRes = isEmailLogin ? await loginSubmitApi(loginData, resGeetestValidate) : await mobileLoginApi({ ...loginData, ...mobileLoginData }, resGeetestValidate);
                if (tokenRes.token) {
                    applyAuthInterceptor(tokenRes.token);
                    await this.onLoginSuccess({
                        isBindWecaht: true,
                        callbackValue: this.callbackValue,
                    });
                }
            }
            catch (e) {
                let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
                const loginUrl = _.get(e, 'response.data.loginurl');
                const status = _.get(e, 'response.status');
                if (status === 500) {
                    // 服务器错误直接-1
                    // passport服务错误中也有 `number_error_code`
                    errorCode = -1;
                }
                // 手机登录 Invalid 或 用户账号被锁定
                if (!isEmailLogin) {
                    // 提示用户使用短信登录。
                    errorCode === 30116 && (errorCode = 30116.1);
                    if (errorCode === 30103 || errorCode === 30101) {
                        errorCode = 30103.1;
                    }
                }
                // 缓存
                if (errorCode === 30122 || errorCode === 30116.1) {
                    setUserAccountMobileNumber(loginBaseData.mobile_number, this.formSms.purpose);
                }
                if (errorCode) {
                    const { msg } = this.getToastMsg(errorCode, email, loginUrl);
                    this.bindExistAccountAlertConfig.showAlert = true;
                    this.bindExistAccountAlertConfig.type = E_AlertType.error;
                    this.bindExistAccountAlertConfig.content = msg;
                    this.bindExistAccountAlertConfig.title = '';
                }
            }
            finally {
                this.isLoading = false;
            }
        });
        PendoInsertMeta('Login', 'Wechat Binding Final');
    }
    smsLoginSubmitFail() {
        this.isLoading = false;
    }
    async smsLoginSubmit(data, needLoginCheck = true, isBindExistAccount = this.IsBindExistAccount) {
        if (!isBindExistAccount) {
            if (!this.agreeLegal) {
                this.tippyJsErrorInstanceToggle();
                return;
            }
        }
        try {
            if (needLoginCheck) {
                const preLoginParams = {
                    client_id: this.clientId,
                    from_freemium: true,
                    ...data,
                };
                const checkStatus = await this.beforeLoginCheck(preLoginParams, E_LoginMethod.sms, isBindExistAccount);
                if (!checkStatus)
                    return;
            }
            let urlParams = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
            let tokenRes;
            if (!isBindExistAccount) {
                if (this.isInvitationRegister) {
                    urlParams = {
                        ...urlParams,
                        ...this.commonService.redirectUrlQueryData,
                        ...!_.isEmpty(this.invitationCompany) ? { manual_company: this.invitationCompany } : {},
                    };
                }
                tokenRes = await mobileLoginRegisterApi({
                    from: this.from,
                    verify_code: data.verify_code,
                    remember_me: true,
                }, {
                    mobile_number: data.mobile_number,
                    country_code: data.country_code,
                    response_type: 'TOKEN',
                    client_id: this.clientId,
                    ...urlParams,
                });
            }
            else {
                tokenRes = await postLoginVerifyCode({
                    ...data,
                    remember_me: E_Switch.On,
                    client_id: this.clientId,
                    from: this.from,
                    response_type: 'TOKEN',
                });
            }
            removeMobileVerifyCodeCountDownTime(this.FormSmsPurpose);
            if (tokenRes.token) {
                applyAuthInterceptor(tokenRes.token);
                await this.onLoginSuccess({
                    isBindWecaht: true,
                    callbackValue: this.callbackValue,
                });
            }
        }
        catch (e) {
            this.handleError(e, data);
        }
        finally {
            this.isLoading = false;
        }
    }
    async emailVerifyLogin(data, needLoginCheck = true) {
        try {
            if (needLoginCheck) {
                const preLoginParams = {
                    client_id: this.clientId,
                    ...data,
                };
                const checkStatus = await this.beforeLoginCheck(preLoginParams, E_LoginMethod.emailVerifyCode, true);
                if (!checkStatus)
                    return;
            }
            const tokenRes = await postLoginEmailVerifyCode({
                ...data,
                remember_me: E_Switch.On,
                client_id: this.clientId,
                from: this.from,
                response_type: 'TOKEN',
            });
            removeVerifyCodeCountDownTime(E_EMAIL_VERIFYCODE_PURPOSE.LOGIN + '_EMAIL');
            if (tokenRes.token) {
                applyAuthInterceptor(tokenRes.token);
                await this.onLoginSuccess({
                    isBindWecaht: true,
                    callbackValue: this.callbackValue,
                });
            }
        }
        catch (e) {
            this.handleError(e, data);
        }
        finally {
            this.isLoading = false;
        }
    }
    get paramsUrl() {
        const params = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
        return postVar({ ...params });
    }
    get SigupUrl() {
        return `${this.commonService.AccountHost}/public/?${this.paramsUrl}#/register`;
    }
    handleError(e, data) {
        let errorCode = _.get(e, 'response.data.errcode') || _.get(e, 'response.data.numeric_error_code');
        const status = _.get(e, 'response.status');
        const loginUrl = _.get(e, 'response.data.loginurl');
        if (status === 500) {
            // 服务器错误直接-1
            // passport服务错误中也有 `number_error_code`
            errorCode = -1;
        }
        if (errorCode === 30101 && !this.IsBindExistAccount) {
            this.smsLoginSubmit(data, false, false);
            return;
        }
        errorCode === 30101 && (errorCode = 30101.1);
        errorCode === 30103 && (errorCode = 30103.1);
        if (errorCode) {
            let { msg } = this.getToastMsg(errorCode, '', loginUrl);
            if (errorCode === '30136') {
                msg = this.$t('passport.register.needEmailRegisterPleaseGoRegisterPage', { url: this.SigupUrl });
            }
            if (this.IsBindExistAccount) {
                this.bindExistAccountAlertConfig.showAlert = true;
                this.bindExistAccountAlertConfig.type = E_AlertType.error;
                this.bindExistAccountAlertConfig.content = msg;
                this.bindExistAccountAlertConfig.title = '';
                return;
            }
            this.alertConfig.showAlert = true;
            this.alertConfig.type = E_AlertType.error;
            this.alertConfig.content = msg;
            this.alertConfig.title = '';
        }
    }
    onLogin(data) {
        this.isLoading = true;
        if (data.mobile_number) {
            this.smsLoginSubmit(data, false, true);
        }
        if (data.email) {
            this.emailVerifyLogin(data, false);
        }
        PendoInsertMeta('Register', 'Wechat Registered');
    }
    async loginRegisterSuccess(data) {
        if (data.token) {
            applyAuthInterceptor(data.token);
            await this.onLoginSuccess({
                isBindWecaht: true,
                callbackValue: this.callbackValue,
            });
        }
    }
    onAlertMsgUpdate(data) {
        this.alertConfig = data;
    }
    smsBindSubmit() {
        if (this.isLoading)
            return;
        this.isLoading = true;
        this.formSmsRef.submit();
        PendoInsertMeta('Login', 'Wechat Binding Final');
    }
};
__decorate([
    Prop({
        type: String,
        required: true,
    }),
    __metadata("design:type", Object)
], WechatBindDialogImpl.prototype, "callbackValue", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], WechatBindDialogImpl.prototype, "isInvitationRegister", void 0);
__decorate([
    Prop({
        type: String,
        default: '',
    }),
    __metadata("design:type", String)
], WechatBindDialogImpl.prototype, "invitationCompany", void 0);
__decorate([
    Watch('curBindWay'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], WechatBindDialogImpl.prototype, "onCurBindWayChange", null);
WechatBindDialogImpl = __decorate([
    Component({
        name: 'WechatBindDialog',
        components: {
            PsInput,
            MobileVerifyCodeForm,
            ElDialog: Dialog,
            ElButton: Button,
            ElForm: Form,
            ElFormItem: FormItem,
            ElCheckbox: Checkbox,
            Alert,
            TermsOfServiceUpdate,
        },
    })
], WechatBindDialogImpl);
export { WechatBindDialogImpl };
